var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",class:_vm.className,style:(_vm.divStyle),attrs:{"id":_vm.getId}})}
var staticRenderFns = []

export { render, staticRenderFns }